import React from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { overlay } from 'overlay-kit';
import { logger } from '@zep/core-logger';
import { ArrowTurnUprightOutlinedIcon } from '@/icons';
import { NextQuizset } from '@/shared/components';
import { useUpsellingGuard, useUserPlanManager } from '@/shared/plan';
import { BuildProFeatureCoachmarkAnchor } from '../components/BuildProFeatureCoachmark';
import { FeatureUpsellModal } from '../components/FeatureUpsellModal';
import { useBuildFormContext } from '../form/schema';
import { useOpenNextQuizsetSelectModal } from '../hook/useOpenNextQuizsetSelectModal';
import { ToggleOptionContainer } from './ToggleOptionContainer';
export const ToggleNextQuizsetField = () => {
  const {
    watch,
    setValue
  } = useBuildFormContext();
  const {
    t
  } = useTranslation(['build']);
  const {
    userPlanManager
  } = useUserPlanManager();
  const upsellingGuard = useUpsellingGuard();
  const featurePlanType = userPlanManager.getFeaturePlanType('CONTINUE_NEXT_QUIZSET');
  const openNextQuizsetSelectModal = useOpenNextQuizsetSelectModal();
  const currentQuizsetId = watch('id');
  const isNextQuizsetAvailable = watch('isNextQuizsetAvailable');
  const nextQuizsetId = watch('nextQuizsetId');
  const selectQuizset = async () => {
    const quizsetId = await openNextQuizsetSelectModal({
      excludeQuizsetIds: currentQuizsetId ? [currentQuizsetId] : []
    });
    if (typeof quizsetId === 'string') {
      setValue('nextQuizsetId', quizsetId, {
        shouldDirty: true,
        shouldTouch: true
      });
      setValue('isNextQuizsetAvailable', true, {
        shouldDirty: true,
        shouldTouch: true
      });
    }
  };
  const handleToggle = async () => {
    logger.track('nextQuizsetAvailable_select', {
      value: !isNextQuizsetAvailable
    });
    void upsellingGuard(async () => {
      if (isNextQuizsetAvailable) {
        setValue('isNextQuizsetAvailable', false, {
          shouldDirty: true,
          shouldTouch: true
        });
        return;
      } else {
        if (nextQuizsetId) {
          setValue('isNextQuizsetAvailable', true, {
            shouldDirty: true,
            shouldTouch: true
          });
        } else {
          logger.track('openNextQuizsetSelectModal_create');
          await selectQuizset();
        }
      }
    }, {
      feature: 'CONTINUE_NEXT_QUIZSET',
      from: 'nextQuizset',
      onGuard: () => {
        overlay.open(({
          unmount
        }) => <FeatureUpsellModal feature="CONTINUE_NEXT_QUIZSET" onClose={unmount} />);
      }
    });
  };
  return <div className="flex flex-col gap-sm" data-sentry-component="ToggleNextQuizsetField" data-sentry-source-file="ToggleNextQuizsetField.tsx">
      <ToggleOptionContainer optionIcon={<ArrowTurnUprightOutlinedIcon size="sm" fill={ICON_COLOR.neutral} />} optionTitle={t('build:settings.nextQuizset.title')} optionDescription={t('build:settings.nextQuizset.description')} isOn={isNextQuizsetAvailable} onToggle={handleToggle} planType={featurePlanType} isBadgeVisible={true} renderToggle={toggle => <BuildProFeatureCoachmarkAnchor feature="CONTINUE_NEXT_QUIZSET">
            {toggle}
          </BuildProFeatureCoachmarkAnchor>} data-sentry-element="ToggleOptionContainer" data-sentry-source-file="ToggleNextQuizsetField.tsx" />
      {isNextQuizsetAvailable && <NextQuizset quizsetId={watch('nextQuizsetId')} enableChange onChangeButtonClick={async () => {
      logger.track('openNextQuizsetSelectModal_edit');
      await selectQuizset();
    }} />}
    </div>;
};